import ElectronicInvoiceApi from './components/electronicInvoiceApi/index.vue';
import OrderBillingApi from './components/orderBillingApi';

const components = [
  ElectronicInvoiceApi,
  OrderBillingApi,
];

const install = function (Vue) {
  if (install.installed) return;
  components.map(component => Vue.component(component.name, component));
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  ElectronicInvoiceApi,
  OrderBillingApi,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sditest/electronic-invoice-api/src/index.js
// module id = ZJp+
// module chunks = 70